import React, { FunctionComponent } from 'react';
import { CompanyDetailInformationChild } from '../../molecules/companyDetailInformationChild'; 
import type { CompanyDetailInformation } from '../../../types/companyDetail';

type Props = {
  isPc: boolean;
  informationFixedTitle: string;
  missionFixedTitle: string;
  profile: CompanyDetailInformation;
};

export const Presentation: FunctionComponent<Props> = ({
  isPc,
  informationFixedTitle,
  missionFixedTitle,
  profile,
}) => {
  const hasInformation = profile.informationTitle !== null;
  const hasMission = profile.missionTitle !== null;

  return (
    <>
      {hasInformation && (
        <CompanyDetailInformationChild
          isPc={isPc}
          FixedTitle={informationFixedTitle}
          Title={profile.informationTitle || ''}
          description={profile.informationDescription || ''}
          image1={profile.informationImage1 || null}
          Image1Description={profile.informationImage1Description || ''}
          image2={profile.informationImage2 || null}
          Image2Description={profile.informationImage2Description || ''}
        />
      )}

      {hasMission && (
        <CompanyDetailInformationChild
          isPc={isPc}
          FixedTitle={missionFixedTitle}
          Title={profile.missionTitle || ''}
          description={profile.missionDescription || ''}
          image1={profile.missionImage1 || null}
          Image1Description={profile.missionImage1Description || ''}
          image2={profile.missionImage2 || null}
          Image2Description={profile.missionImage2Description || ''}
        />
      )}
    </>
  );
};
